import React, { useEffect, useState } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';
import { useAuth } from '../../context/Auth';

type Props = {
    actingBodyId?: number;
    disabled: boolean;
    zIndex: number;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    labelFontSize?: number;
    includeDeleted?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function UnitNameDropdown({ form, fieldName, value, setValue, actingBodyId, disabled, zIndex, required, labelStyle, viewStyle, labelFontSize = 16, includeDeleted }: Props) {
    const [selectableUnitNames, setSelectableUnitNames] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getUnitNames(actingBodyId?: number) {
        try {
            const unitNames = await dispatchService.getUnitNames(actingBodyId, includeDeleted);
            setSelectableUnitNames([
                ...unitNames.map((role) => {
                    return { value: role.id, label: role.name };
                })
            ]);

        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if ((authenticatedUser?.isAdmin
            || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_units
            || authenticatedUser?.permissions.dispatch_manage_acting_body_units) && !actingBodyId) {
            setSelectableUnitNames([]);
            return;
        }

        getUnitNames(actingBodyId);
    }, [actingBodyId]);


    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('name')}
            items={selectableUnitNames}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('name')}
                items={selectableUnitNames}
                multiple={false}
                setValue={setValue}
                value={value}
                disabled={disabled}
                zIndex={zIndex}
                required={required}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
                labelFontSize={labelFontSize}
            />
        );
    }
}

export default UnitNameDropdown;
